import { render, staticRenderFns } from "./wilayah.vue?vue&type=template&id=283e0da3&"
import script from "./wilayah.vue?vue&type=script&lang=js&"
export * from "./wilayah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports